// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function resetState(st) {
  var timerId = st.timerId;
  if (timerId !== undefined) {
    clearTimeout(Caml_option.valFromOption(timerId));
  }
  return {
          lastClickBeginTime: st.lastClickBeginTime,
          lastClickEndTime: st.lastClickEndTime,
          timerId: undefined,
          clickBeginScreenX: st.clickBeginScreenX,
          clickBeginScreenY: st.clickBeginScreenY,
          doShortClick: undefined,
          doLongClick: undefined
        };
}

function shouldDoLongClick(st) {
  var timerIdActual = st.doLongClick;
  if (timerIdActual === undefined) {
    return false;
  }
  var timerIdExpected = st.timerId;
  if (timerIdExpected !== undefined) {
    return Caml_obj.equal(Caml_option.valFromOption(timerIdExpected), Caml_option.valFromOption(timerIdActual));
  } else {
    return false;
  }
}

function useLongClick(onClick, longClickEnabled, longClickDelayMs, onShortClick, onLongClick) {
  var match = React.useState(function () {
        return {
                lastClickBeginTime: 0,
                lastClickEndTime: 0,
                timerId: undefined,
                clickBeginScreenX: 0,
                clickBeginScreenY: 0,
                doShortClick: undefined,
                doLongClick: undefined
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          var clickAttrsOpt = state.doShortClick;
          if (clickAttrsOpt !== undefined) {
            var clickAttrsOpt$1 = Caml_option.valFromOption(clickAttrsOpt);
            setState(resetState);
            Belt_Option.forEach(onShortClick, (function (onShortClick) {
                    onShortClick(clickAttrsOpt$1);
                  }));
          }
          
        }), [state.doShortClick]);
  React.useEffect((function () {
          if (shouldDoLongClick(state)) {
            setState(resetState);
            Belt_Option.forEach(onLongClick, (function (onLongClick) {
                    onLongClick();
                  }));
          }
          
        }), [state.doLongClick]);
  var actClickBegin = function (screenX, screenY) {
    setState(function (__x) {
          if (Date.now() - __x.lastClickBeginTime <= 300) {
            return __x;
          }
          var init = resetState(__x);
          var timerIdLocal = {
            contents: undefined
          };
          return {
                  lastClickBeginTime: Date.now(),
                  lastClickEndTime: init.lastClickEndTime,
                  timerId: (timerIdLocal.contents = Caml_option.some(setTimeout((function () {
                                var timerId = timerIdLocal.contents;
                                if (timerId === undefined) {
                                  return ;
                                }
                                var timerId$1 = Caml_option.valFromOption(timerId);
                                setState(function (__x) {
                                      return {
                                              lastClickBeginTime: __x.lastClickBeginTime,
                                              lastClickEndTime: __x.lastClickEndTime,
                                              timerId: __x.timerId,
                                              clickBeginScreenX: __x.clickBeginScreenX,
                                              clickBeginScreenY: __x.clickBeginScreenY,
                                              doShortClick: undefined,
                                              doLongClick: Caml_option.some(timerId$1)
                                            };
                                    });
                              }), longClickDelayMs)), timerIdLocal.contents),
                  clickBeginScreenX: screenX,
                  clickBeginScreenY: screenY,
                  doShortClick: init.doShortClick,
                  doLongClick: init.doLongClick
                };
        });
  };
  var actClickEnd = function (mEvt) {
    setState(function (__x) {
          if (Date.now() - __x.lastClickEndTime <= 300) {
            return __x;
          }
          var timerId = __x.timerId;
          if (timerId !== undefined) {
            clearTimeout(Caml_option.valFromOption(timerId));
          }
          return {
                  lastClickBeginTime: __x.lastClickBeginTime,
                  lastClickEndTime: Date.now(),
                  timerId: undefined,
                  clickBeginScreenX: __x.clickBeginScreenX,
                  clickBeginScreenY: __x.clickBeginScreenY,
                  doShortClick: Belt_Option.map(__x.timerId, (function (param) {
                          return Belt_Option.map(mEvt, (function (evt) {
                                        return {
                                                alt: evt.altKey,
                                                shift: evt.shiftKey,
                                                ctrl: evt.ctrlKey
                                              };
                                      }));
                        })),
                  doLongClick: undefined
                };
        });
  };
  var actClickMove = function (screenX, screenY) {
    if (Belt_Option.isSome(state.timerId) && (Math.abs(state.clickBeginScreenX - screenX | 0) > 3 || Math.abs(state.clickBeginScreenY - screenY | 0) > 3)) {
      return setState(resetState);
    }
    
  };
  var actMouseMove = function (evt) {
    if (longClickEnabled) {
      return actClickMove(evt.screenX, evt.screenY);
    }
    
  };
  var getScreenCoordsFromTouchList = function (touchList) {
    if (touchList.length <= 0) {
      return ;
    }
    var touch = touchList.item(0);
    return [
            touch.screenX,
            touch.screenY
          ];
  };
  var actTouchMove = function (evt) {
    if (!longClickEnabled) {
      return ;
    }
    var match = getScreenCoordsFromTouchList(evt.touches);
    if (match !== undefined) {
      return actClickMove(match[0], match[1]);
    }
    
  };
  var actTouchCancel = function (param) {
    if (longClickEnabled) {
      return setState(resetState);
    }
    
  };
  return {
          onClick: (function (evt) {
              if (!longClickEnabled && Belt_Option.isSome(onClick)) {
                return Curry._1(Belt_Option.getExn(onClick), evt);
              }
              
            }),
          onMouseDown: (function (evt) {
              if (longClickEnabled) {
                return actClickBegin(evt.screenX, evt.screenY);
              }
              
            }),
          onMouseUp: (function (evt) {
              if (longClickEnabled) {
                return actClickEnd(Caml_option.some(evt));
              }
              
            }),
          onMouseMove: actMouseMove,
          onMouseLeave: actMouseMove,
          onMouseOut: actMouseMove,
          onTouchStart: (function (evt) {
              if (!longClickEnabled) {
                return ;
              }
              var match = getScreenCoordsFromTouchList(evt.touches);
              if (match !== undefined) {
                return actClickBegin(match[0], match[1]);
              }
              
            }),
          onTouchEnd: (function (param) {
              if (longClickEnabled) {
                return actClickEnd(undefined);
              }
              
            }),
          onTouchMove: actTouchMove,
          onTouchCancel: actTouchCancel
        };
}

var repeatDelayMs = 300;

exports.useLongClick = useLongClick;
exports.repeatDelayMs = repeatDelayMs;
/* react Not a pure module */
